export const getLastNameWithInitials: (firstName: string, lastName: string, middleName?: string) => string = (
    firstName,
    lastName,
    middleName,
) => `${lastName} ${firstName ? firstName[0] + '. ' : ''}${middleName ? middleName[0] + '.' : ''}`;
